import React from 'react';
import { Col, Row, Tooltip } from 'antd';
import { FlyingAircraftIcon } from './icons/FlyingAircraftIcon';
import { FlyingSpiderTxtIcon } from './icons/FlyingSpiderTxtIcon';
import { FlightDetail } from '../../types/flyingPage';
const COLUMN_FLEX_STYLE = { display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' };

interface CollapsedFlightDetailHeaderProps {
  flightDetails: FlightDetail;
  flightActive: boolean;
}
export const CollapsedFlightDetailHeader: React.FC<CollapsedFlightDetailHeaderProps> = ({
  flightDetails,
  flightActive
}) => {
  return (
    <Row>
      <Col span={14}>
        <Row style={{ fontSize: '1.1em' }}>
          {flightDetails.aircraft.registration.length > 11 ? (
            <Tooltip placement="right" title={flightDetails.aircraft.registration} trigger="hover">
              <b>{flightDetails.aircraft.registration.substring(0, 11)}...</b>
            </Tooltip>
          ) : (
            <b>{flightDetails.aircraft.registration}</b>
          )}
        </Row>
      </Col>
      <Col offset={3} span={7}>
        <Row type="flex" justify="end" align="bottom" style={{ gap: '4px' }}>
          <Col style={COLUMN_FLEX_STYLE}>
            {flightActive && (
              <FlyingSpiderTxtIcon
                enabled={!!flightDetails.track.aircraft.activeDeviceConnection}
                userDisplayName={
                  flightDetails.track.aircraft.activeDeviceConnection
                    ? flightDetails.track.aircraft.activeDeviceConnection.user?.displayName
                    : undefined
                }
              />
            )}
          </Col>
          <Col style={{ ...COLUMN_FLEX_STYLE, marginLeft: '-4px' }}>
            <FlyingAircraftIcon aircraftId={flightDetails.track.aircraft.id} />
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
